import { Skeleton } from "antd";
import React, { } from "react";
import Container from "../../General/Container/Container";
import PersonasTargetItem from "./PersonasTargetItem";

const PersonasMarketingApproach = ({
    loading,
    personaName,
    classColor,
    data = [],
    forPrint
}) => {
    const forPrintStyle = forPrint ? { width: "50%" } : { width: "calc(33% - 2mm)" }
    return <Container className="minified-result-item dcol download-personas">
        {loading
            ? <Skeleton paragraph={{ rows: 2 }} active />
            : <>
                <span className={`personas-title${classColor}`}>Marketing Approach</span>
                <p>To effectively reach {personaName}, a marketing campaign should emphasize the following elements:</p>
            </>
        }
        <Container className="dwrap">
            {loading
                ? "11111".split("").map(() => {
                    return <PersonasTargetItem loading />
                })
                : data.map((text, index) => {
                    return <PersonasTargetItem
                        key={`market-approach-${index}`}
                        text={text}
                        classColor={classColor}
                        style={forPrintStyle}
                        forPrint={forPrint}
                    />
                })
            }
        </Container>
    </Container>
}

export default PersonasMarketingApproach